import { v4 as uuidV4 } from 'uuid';

export default function uniqueId () {
  return uuidV4();
}
